var _rect, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesforceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    role: "img",
    "aria-label": "Salesforce Marketing Cloud",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 22,
    fill: "#0b8fca"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 58c-8.3 0-15-6.3-15-14.1 0-7.2 5.7-13.2 13.2-14 3.5-8.6 12.1-14.7 22.2-14.7 12.2 0 22.3 8.9 23.7 20.3 6.4 1.5 11.2 7 11.2 13.6C83.3 56.8 76.7 63 68.6 63H28z",
    fill: "#fff",
    opacity: 0.96
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 54,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#0876a8"
  }, "MC")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforceLogo);
export default __webpack_public_path__ + "static/media/salesforceLogo.8f0d820ac7b228aca1383e7431281568.svg";
export { ForwardRef as ReactComponent };